(() => {
    if (window.location.href.includes("cart")) {
      sessionStorage.setItem('redirectedFromCartPage', 'true');
      window.location.href = "/collections/alle-produkte";
    } else {
       // open cart if redirected from /cart page
      if (sessionStorage.getItem('redirectedFromCartPage') === 'true') {
          const interval = setInterval(() => {
                const cartDrawerOpen = document.querySelector('html.cart-drawer--open');
                const openCartButton = document.querySelector('.header__cart-toggle');

                if (openCartButton != undefined) {
                    openCartButton.click();
                    sessionStorage.setItem('redirectedFromCartPage', 'false');
                }

                if(cartDrawerOpen) {
                    clearInterval(interval);
                }
          }, 200);
      }
    }
})();